// READ: https://www.notion.so/outverse/Clickoutside-events-Portals-and-madness-9233c5aa000d4471828fbffb0adfb17c

export function clickOutside(element: HTMLElement, callbackFunction: () => any) {
  const onClick = (event: MouseEvent) => {
    if (!(event.target instanceof HTMLElement)) {
      return;
    }

    // if the element is a portal and has a sibling then do not execute the callback function.
    if (
      element.classList.contains("portal") &&
      element.nextElementSibling?.classList.contains("portal")
    ) {
      return;
    }

    // In cases where a non-portal element contains a portal element,
    // and both have clickOutside events attached(e.g., a sidebar with a dropdown on mobile),
    // you need a solution to close only the dropdown when clicking outside
    // so: if the element is not a portal and the click is on a portal don't execute the callback function.
    // we still use the z-modal class in the if statement for eleements that are yet to be made portals when sveltified
    if (
      !element.classList.contains("portal") &&
      (event.target?.closest(".portal") || event.target?.closest(".z-modal"))
    ) {
      return;
    }

    if (event.target && !element.contains(event.target)) {
      if (callbackFunction()) {
        event.preventDefault();
      }
    }
  };

  // wait for the DOM to update before attaching the event listener
  // this because the event listener may being set up before the component has finished rendering
  // and the click event on a button could trigger the callback function immediately
  const timer = setTimeout(() => {
    document.body.addEventListener("click", onClick);
  }, 0);

  // Destroy takes no parameters and runs whenever the object is removed from the DOM.
  // Update takes any or all of the parameters from your action and runs whenever those change.
  return {
    update(newCallbackFunction: () => any) {
      callbackFunction = newCallbackFunction;
    },
    destroy() {
      clearTimeout(timer);
      document.body.removeEventListener("click", onClick);
    },
  };
}
